export interface IObject {
  [key: string]: any;
};

export interface IIconProps {
  type?: string;
  className?: string;
  svgClassName?: string;
  size?: number;
  opacity?: number;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

export interface IDeliveryAddress {
  name: string;
  phone: string;
  delivery_date?: string;
  country?: string;
  province?: string;
  city?: string;
  state?: string;
  district?: string;
  street?: string;
  address?: string;
  address1?: string;
  lat?: string;
  lng?: string;
  area?: any;
  note?: string;
};

export enum IDiningMethods {
  TAKEAWAY = 0,
  DELIVERY = 1,
  DINE_IN = 2,
};

export interface IPickUpOption {
  name: string;
  phone: string;
  delivery_date: string;
}

export interface IAreaCodes {
  isoAlpha2Code: string;
  isoAlpha3Code: string;
  name: string;
  phoneCountryCode: string;
  __i18n: IObject;
  translations?: IObject[];
}